import { render, staticRenderFns } from "./VProjectManagementTools.vue?vue&type=template&id=0b9b63ea&"
import script from "./VProjectManagementTools.vue?vue&type=script&lang=ts&"
export * from "./VProjectManagementTools.vue?vue&type=script&lang=ts&"
import style0 from "./VProjectManagementTools.vue?vue&type=style&index=0&id=0b9b63ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports